/**
 * Determines whether a document should be view-only (no action buttons).
 * A document is view-only when it belongs to a non-current requirement
 * AND is not pending approval. Pending documents always need action buttons
 * regardless of the requirement's is_current status.
 */
export function isDocumentViewOnly(doc: {
  udr_is_current: boolean | null;
  status: string;
}): boolean {
  return doc.udr_is_current === false && doc.status !== 'pending_approval';
}

/**
 * Determines whether approve/reject buttons should be shown for a document.
 */
export function shouldShowApproveRejectButtons(doc: {
  udr_is_current: boolean | null;
  status: string;
  rejection_reason?: string | null;
}): boolean {
  if (isDocumentViewOnly(doc)) return false;
  if (doc.status !== 'pending_approval') return false;

  const hasRevisionRequest = doc.rejection_reason?.startsWith('SOLICITUD DE REVISIÓN:') ?? false;
  if (hasRevisionRequest) return false;

  return true;
}

/**
 * Determines whether the "Solicitar Revisión" button should be shown.
 * Any approved document can be sent back for review, even when its
 * requirement is not flagged as current (is_current is not reliable per period).
 */
export function shouldShowRevisionButton(doc: {
  udr_is_current: boolean | null;
  status: string;
}): boolean {
  return doc.status === 'approved';
}
